import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, X, Minus, ArrowRight } from 'lucide-react';

const ComparePackagesPage = () => {
  const navigate = useNavigate();

  const comparisonData = {
    features: [
      {
        category: 'الاستشارات القانونية',
        items: [
          {
            name: 'عدد الاستشارات الشهرية',
            basic: '3 استشارات',
            plus: '6 استشارات',
            premium: 'شبه غير محدودة',
            platinum: 'غير محدودة',
            elite: 'غير محدودة',
            custom: 'حسب الطلب'
          },
          {
            name: 'نوع الاستشارات',
            basic: 'هاتفية/أونلاين',
            plus: 'هاتفية/مرئية/حضور',
            premium: 'جميع الأنواع',
            platinum: 'جميع الأنواع',
            elite: 'جميع الأنواع + حضور دوري',
            custom: 'حسب الطلب'
          }
        ]
      },
      {
        category: 'العقود',
        items: [
          {
            name: 'مراجعة العقود شهرياً',
            basic: '1 عقد',
            plus: '3 عقود',
            premium: '6 عقود',
            platinum: '10 عقود',
            elite: 'غير محدود',
            custom: 'حسب الطلب'
          },
          {
            name: 'صياغة عقود جديدة',
            basic: false,
            plus: false,
            premium: '2 عقد شهرياً',
            platinum: '5 عقود شهرياً',
            elite: 'غير محدود',
            custom: 'حسب الطلب'
          }
        ]
      },
      {
        category: 'دعم الموارد البشرية',
        items: [
          {
            name: 'دعم قانوني للموارد البشرية',
            basic: false,
            plus: 'مراجعة بسيطة',
            premium: 'دعم كامل',
            platinum: 'دعم كامل + لوائح',
            elite: 'دعم كامل + تحديثات دورية',
            custom: 'حسب الطلب'
          },
          {
            name: 'إعداد لوائح تنظيم العمل',
            basic: false,
            plus: false,
            premium: false,
            platinum: true,
            elite: true,
            custom: 'حسب الطلب'
          }
        ]
      },
      {
        category: 'إدارة القضايا',
        items: [
          {
            name: 'إدارة القضايا',
            basic: 'خصم 10٪',
            plus: 'خصم 20٪',
            premium: 'خصم 30٪',
            platinum: 'مشمولة جزئياً',
            elite: 'مشمولة بالكامل',
            custom: 'حسب الطلب'
          }
        ]
      },
      {
        category: 'حضور المحامي',
        items: [
          {
            name: 'حضور المحامي في المقر',
            basic: false,
            plus: 'عند الحاجة',
            premium: 'مرة كل أسبوعين',
            platinum: 'أسبوعياً',
            elite: 'حسب الحاجة + اجتماعات مجلس',
            custom: 'حسب الطلب'
          }
        ]
      },
      {
        category: 'التقارير والمتابعة',
        items: [
          {
            name: 'التقارير الدورية',
            basic: false,
            plus: 'ربع سنوي',
            premium: 'شهري',
            platinum: 'شهري مفصّل',
            elite: 'شهري/أسبوعي حسب الطلب',
            custom: 'حسب الطلب'
          },
          {
            name: 'مدير حساب قانوني مخصص',
            basic: false,
            plus: false,
            premium: false,
            platinum: true,
            elite: 'Legal Account Director',
            custom: 'حسب الطلب'
          }
        ]
      },
      {
        category: 'الدعم والأولوية',
        items: [
          {
            name: 'أولوية الدعم',
            basic: 'عادية',
            plus: 'عادية',
            premium: 'عالية',
            platinum: 'عالية جداً',
            elite: 'VIP',
            custom: 'حسب الطلب'
          },
          {
            name: 'قناة تواصل مباشرة',
            basic: 'نظام التذاكر',
            plus: 'نظام التذاكر',
            premium: 'نظام التذاكر + بريد',
            platinum: 'واتساب + بريد',
            elite: 'خط VIP مخصص',
            custom: 'حسب الطلب'
          }
        ]
      },
      {
        category: 'الحوكمة والامتثال',
        items: [
          {
            name: 'منظومة حوكمة وامتثال',
            basic: false,
            plus: false,
            premium: false,
            platinum: false,
            elite: 'تصميم وتنفيذ كامل',
            custom: 'حسب الطلب'
          }
        ]
      },
      {
        category: 'السعر',
        items: [
          {
            name: 'السعر الشهري',
            basic: '2,500 - 4,000 ريال',
            plus: '5,000 - 8,000 ريال',
            premium: '10,000 - 15,000 ريال',
            platinum: '20,000 - 35,000 ريال',
            elite: '50,000 - 120,000 ريال',
            custom: 'حسب التقييم'
          },
          {
            name: 'السعر السنوي',
            basic: '25,000 - 40,000 ريال',
            plus: '55,000 - 85,000 ريال',
            premium: '110,000 - 160,000 ريال',
            platinum: '220,000 - 380,000 ريال',
            elite: '600,000 - 1,200,000 ريال',
            custom: 'حسب التقييم'
          }
        ]
      }
    ]
  };

  const renderCell = (value) => {
    if (value === true) {
      return <CheckCircle className="text-green-500 mx-auto" size={24} />;
    }
    if (value === false) {
      return <X className="text-gray-300 mx-auto" size={24} />;
    }
    if (value === null || value === undefined) {
      return <Minus className="text-gray-300 mx-auto" size={24} />;
    }
    return <span className="text-sm text-gray-700 text-center block">{value}</span>;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100" dir="rtl">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-amber-700 to-amber-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">
            قارن بين الباقات
          </h1>
          <p className="text-xl text-center text-amber-100">
            جدول مقارنة شامل لجميع الباقات القانونية
          </p>
        </div>
      </div>

      {/* Comparison Table */}
      <div className="container mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Desktop View */}
          <div className="hidden lg:block overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-50">
                  <th className="p-4 text-right font-bold text-gray-900 border-b-2 border-gray-200 sticky right-0 bg-gray-50 z-10">
                    الميزة
                  </th>
                  <th className="p-4 text-center font-bold text-blue-900 border-b-2 border-blue-200 bg-blue-50">
                    وازن بيسك
                  </th>
                  <th className="p-4 text-center font-bold text-green-900 border-b-2 border-green-200 bg-green-50">
                    وازن بلس
                  </th>
                  <th className="p-4 text-center font-bold text-purple-900 border-b-2 border-purple-200 bg-purple-50">
                    وازن بريميوم
                  </th>
                  <th className="p-4 text-center font-bold text-amber-900 border-b-2 border-amber-200 bg-amber-50">
                    وازن بلاتينيوم
                  </th>
                  <th className="p-4 text-center font-bold text-rose-900 border-b-2 border-rose-200 bg-rose-50">
                    وازن إيليت
                  </th>
                  <th className="p-4 text-center font-bold text-teal-900 border-b-2 border-teal-200 bg-teal-50">
                    وازن كستم
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.features.map((category, categoryIndex) => (
                  <React.Fragment key={categoryIndex}>
                    <tr className="bg-gray-100">
                      <td colSpan="7" className="p-3 font-bold text-gray-900">
                        {category.category}
                      </td>
                    </tr>
                    {category.items.map((item, itemIndex) => (
                      <tr key={itemIndex} className="border-b border-gray-100 hover:bg-gray-50">
                        <td className="p-4 font-medium text-gray-700 sticky right-0 bg-white">
                          {item.name}
                        </td>
                        <td className="p-4 text-center bg-blue-50 bg-opacity-30">
                          {renderCell(item.basic)}
                        </td>
                        <td className="p-4 text-center bg-green-50 bg-opacity-30">
                          {renderCell(item.plus)}
                        </td>
                        <td className="p-4 text-center bg-purple-50 bg-opacity-30">
                          {renderCell(item.premium)}
                        </td>
                        <td className="p-4 text-center bg-amber-50 bg-opacity-30">
                          {renderCell(item.platinum)}
                        </td>
                        <td className="p-4 text-center bg-rose-50 bg-opacity-30">
                          {renderCell(item.elite)}
                        </td>
                        <td className="p-4 text-center bg-teal-50 bg-opacity-30">
                          {renderCell(item.custom)}
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="lg:hidden p-4 space-y-6">
            {comparisonData.features.map((category, categoryIndex) => (
              <div key={categoryIndex} className="space-y-4">
                <h3 className="text-lg font-bold text-gray-900 border-b-2 border-gray-200 pb-2">
                  {category.category}
                </h3>
                {category.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="bg-gray-50 rounded-xl p-4">
                    <h4 className="font-semibold text-gray-900 mb-3">{item.name}</h4>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between items-center">
                        <span className="text-blue-700 font-medium">بيسك:</span>
                        <span className="text-gray-700">{typeof item.basic === 'boolean' ? (item.basic ? '✓' : '✗') : item.basic}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-green-700 font-medium">بلس:</span>
                        <span className="text-gray-700">{typeof item.plus === 'boolean' ? (item.plus ? '✓' : '✗') : item.plus}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-purple-700 font-medium">بريميوم:</span>
                        <span className="text-gray-700">{typeof item.premium === 'boolean' ? (item.premium ? '✓' : '✗') : item.premium}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-amber-700 font-medium">بلاتينيوم:</span>
                        <span className="text-gray-700">{typeof item.platinum === 'boolean' ? (item.platinum ? '✓' : '✗') : item.platinum}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-rose-700 font-medium">إيليت:</span>
                        <span className="text-gray-700">{typeof item.elite === 'boolean' ? (item.elite ? '✓' : '✗') : item.elite}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-teal-700 font-medium">كستم:</span>
                        <span className="text-gray-700">{typeof item.custom === 'boolean' ? (item.custom ? '✓' : '✗') : item.custom}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-12">
          <button
            onClick={() => navigate('/packages')}
            className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:shadow-lg transition-all inline-flex items-center gap-2"
          >
            اختر باقتك الآن
            <ArrowRight size={20} />
          </button>
        </div>
      </div>

      {/* Help Section */}
      <div className="bg-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">
            لا تزال محتاراً في اختيار الباقة؟
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            تواصل معنا وسنساعدك في اختيار الباقة المثالية لاحتياجك
          </p>
          <button
            onClick={() => navigate('/contact')}
            className="bg-amber-900 text-white px-8 py-4 rounded-xl font-bold hover:bg-amber-800 transition-all shadow-lg"
          >
            تحدث مع مستشار
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComparePackagesPage;
